module.exports = __webpack_public_path__ + "img/story-1.b1fcb306.png";